<p-dialog
  header="Validation Result"
  [(visible)]="showValidationResult"
  (visibleChange)="showValidationResultChange.emit($event)"
  [modal]="true"
  [style]="{ width: '860px' }"
  closable="true"
  *ngIf="organisationTypeId == 1 && selectedAdditionalCharge"
>
  <div *ngIf="!selectedAdditionalCharge.additionalExpenseValidations.length">
    No Validation information yet
  </div>

  <p-tabView
    *ngIf="selectedAdditionalCharge.additionalExpenseValidations.length"
    class="no-widget-border"
  >
    <p-tabPanel header="Validation">
      <p-table [value]="selectedAdditionalCharge.additionalExpenseValidations">
        <ng-template pTemplate="header">
          <tr>
            <th>Date and Time</th>
            <th>Type</th>
            <th>Status</th>
            <th>Reason</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-validation>
          <tr>
            <td>
              {{ validation?.modifiedOn || validation?.createdOn | datex : "ddd DD MMM 'YY HH:mm" }}
            </td>
            <td>{{ validation?.validationType?.name | camelToSentenceCase }}</td>
            <td>{{ validation?.validationStatus?.name | camelToSentenceCase }}</td>
            <td>{{ validation?.comment }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Analysis">
      <p-table [value]="[{}]">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Value</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <tr>
            <td>Vendor Name</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.vendorName }}</td>
          </tr>
          <tr>
            <td>Receipt ID</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.receiptId }}</td>
          </tr>
          <tr>
            <td>Receipt Date and Time</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.receiptDateTime
                  | datex : "ddd DD MMM 'YY HH:mm"
              }}
            </td>
          </tr>
          <tr>
            <td>Address Line</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.addressLine }}</td>
          </tr>
          <tr>
            <td>Post Code</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.postCode }}</td>
          </tr>
          <tr>
            <td>City</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.city }}</td>
          </tr>
          <tr>
            <td>Country</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.country }}</td>
          </tr>
          <tr>
            <td>Sub-Total</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.subTotal
                  | currency : 'GBP' : 'symbol' : '1.2-2'
              }}
            </td>
          </tr>
          <tr>
            <td>Tax</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.tax
                  | currency : 'GBP' : 'symbol' : '1.2-2'
              }}
            </td>
          </tr>
          <tr>
            <td>Total Amount</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.totalAmount
                  | currency : 'GBP' : 'symbol' : '1.2-2'
              }}
            </td>
          </tr>
          <tr *ngIf="selectedAdditionalCharge.chargingTimeDuration">
            <td>Charging Time Duration</td>
            <td>
              <span *ngIf="selectedAdditionalCharge.started && selectedAdditionalCharge.ended"
                ><b>Started:</b>
                {{ selectedAdditionalCharge.started | datex : "ddd DD MMM 'YY HH:mm:ss" }} |
                <b>Ended:</b>
                {{ selectedAdditionalCharge.ended | datex : "ddd DD MMM 'YY HH:mm:ss" }}</span
              >
              | <b>Total:</b>
              {{ formatChargingWaitingDuration(selectedAdditionalCharge.chargingTimeDuration) }} |
              <b>ProRated</b>
              {{
                formatChargingWaitingDuration(
                  selectedAdditionalCharge?.proRatedChargingTimeDuration
                )
              }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</p-dialog>
